import React from "react";

import bolita from '../../assets/svgs/avatr/shutter.svg'

interface ScreenshotProps {
  isPortrait: boolean;  
  screenshotURL: any;
  showScreenshotMenu: boolean,
  setShowScreenshotMenu: (value: boolean) => void;
  TakeScreenshot: () => void;
  DownloadScreenshot: () => void;
  setBottomMenu: (value: string) => void;
}

const Screenshot: React.FC<ScreenshotProps> = ({ isPortrait, screenshotURL, showScreenshotMenu, setBottomMenu, setShowScreenshotMenu, TakeScreenshot, DownloadScreenshot}) => {

  const [showScreenshotTaken, setShowScreenshotTaken] = React.useState(false);
  
  const localTakePicture = () => {
    TakeScreenshot();
    setShowScreenshotTaken(true);
  };

  const localTakePictureAgain = () => {
    setShowScreenshotTaken(false);
  };

  const localDownloadScreenshot = () => {
    DownloadScreenshot();
  };

  const closeScreenshotMenu = () => {
    setShowScreenshotMenu(false);
    setShowScreenshotTaken(false);
    setBottomMenu("");
  };

  

  return (
    <div className={`screenshot-full-container ${isPortrait ? 'portrait':''} ${showScreenshotMenu ? '' : 'hide'} ${showScreenshotTaken ? 'background' : ''}`}>
      {/* RETICLE */}
      { !showScreenshotTaken &&
        <div className={`screenshot-reticle-container ${isPortrait ? 'portrait':''}`}>
          <div className={`screenshot-reticle-rows ${isPortrait ? 'portrait':''}`}>
            <div className={`screenshot-reticle-columns ${isPortrait ? 'portrait':''}`}>
                <div className={`screenshot-reticle-tl ${isPortrait ? 'portrait':''}`}/>
                <div className={`screenshot-reticle-tr ${isPortrait ? 'portrait':''}`}/>
            </div>
            <div className={`screenshot-reticle-columns ${isPortrait ? 'portrait':''}`}>
                <div className={`screenshot-reticle-bl ${isPortrait ? 'portrait':''}`}/>
                <div className={`screenshot-reticle-br ${isPortrait ? 'portrait':''}`}/>
            </div>
          </div>
        </div>
      }
      
      {/* PICTURE BUTTON */}
      { !showScreenshotTaken &&
        <div className={`screenshot-capture-container ${isPortrait ? 'portrait':''} ${showScreenshotMenu ? '' : 'hide'}`}>
          <div className={`screenshot-capture-center ${isPortrait ? 'portrait':''}`}>
            <img src={bolita} alt='' className='screenshot-capture-icon' onClick={() => localTakePicture()}/>
            {!isPortrait &&
              <div className={`screenshot-capture-msg`}>
                <div className={`screenshot-capture-text`}>Haz clic y realiza una foto</div>
              </div>
            }
          </div>
        </div>
      }

      {/* PREVIEW */}
      { showScreenshotTaken &&
        <div className={`screenshot-preview-container ${showScreenshotMenu ? '' : 'hide'}`}>
          <div className={`screenshot-preview-center ${isPortrait ? 'portrait':''}`}>
            {screenshotURL && <div className={`screenshot-preview-image ${isPortrait ? 'portrait':''}`} style={{ backgroundImage: `url(${screenshotURL})` }}/>}
            <div className={`screenshot-preview-confirmation ${isPortrait ? 'portrait':''}`}>
                <div className={`screenshot-preview-confirmation-title ${isPortrait ? 'portrait':''}`}>
                    Ésta es tu fotografía
                </div>
                <div className={`screenshot-preview-confirmation-buttons ${isPortrait ? 'portrait':''}`}>
                    <div className={`screenshot-preview-button-download ${isPortrait ? 'portrait':''}`} onClick={() => localDownloadScreenshot()}>
                        <div className={`screenshot-preview-button-download-text ${isPortrait ? 'portrait':''}`}>
                            Descargar fotografía
                        </div>
                    </div>
                    <div className={`screenshot-preview-button-retake ${isPortrait ? 'portrait':''}`} onClick={() => localTakePictureAgain()}>
                        <div className={`screenshot-preview-button-retake-text ${isPortrait ? 'portrait':''}`}>
                            Tomar de nuevo
                        </div>
                    </div>
                    {isPortrait &&
                      <div className={`screenshot-preview-button-retake ${isPortrait ? 'portrait':''}`} onClick={() => closeScreenshotMenu()}>
                        <div className={`screenshot-preview-button-retake-text ${isPortrait ? 'portrait':''}`}>
                          Regresar al vehículo
                        </div>
                    </div>
                    }
                </div>
            </div>
          </div>
        </div>
      }
      
      {/* RETURN BUTTON */}
      {!isPortrait &&
        <div className={`screenshot-return-button ${showScreenshotMenu ? '' : 'hide'}`} onClick={() => closeScreenshotMenu()}>
          <div className={`screenshot-return-text`}>
              Regresar al vehículo
          </div>
        </div>
      }
    </div>
  );
};

export default Screenshot;
